import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  photoGroups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      total: PropTypes.number,
      photos: PropTypes.array,
      loadMore: PropTypes.func,
    }),
  ).isRequired,
  activePhotoGroupIndex: PropTypes.number.isRequired,
  onPhotoGroupIndexChange: PropTypes.func.isRequired,
};

const CardElementPhotoSelectionControlNav = ({
  className,
  photoGroups,
  activePhotoGroupIndex,
  onPhotoGroupIndexChange,
}) => {
  const classes = classNames({
    [className]: !!className,
    'card-photo-selection-control-nav': true,
  });

  return (
    <nav className={classes}>
      {photoGroups.map((photoGroup, index) => (
        <button
          key={photoGroup.id}
          className={classNames({
            'card-photo-selection-control-nav-item': true,
            active: index === activePhotoGroupIndex,
          })}
          onClick={() => onPhotoGroupIndexChange(index)}
        >
          {photoGroup.label}
        </button>
      ))}
    </nav>
  );
};

CardElementPhotoSelectionControlNav.propTypes = propTypes;

export default CardElementPhotoSelectionControlNav;
